import { render } from "./format-form.vue?vue&type=template&id=207009f2&scoped=true"
import script from "./format-form.vue?vue&type=script&lang=js"
export * from "./format-form.vue?vue&type=script&lang=js"

import "./format-form.vue?vue&type=style&index=0&id=207009f2&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207009f2"]])

export default __exports__